import { t } from '@lingui/core/macro';
import { Box, Chip, Tooltip } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { AclAction } from 'shared/domains/apollo/generated/types';
import { getAccessLevelName } from '../AccessManagement/getAccessLevelName';
export function AclChange(props) {
    const { actions } = props;
    const previousAccessLevel = getAccessLevelName(actions.prev);
    const newAccessLevel = getAccessLevelName(actions.next);
    const willGainPartialAccess = actions.next.includes(AclAction.Traverse);
    const tooltip = t({
        message: `Previous access level: ${previousAccessLevel}. New access level: ${newAccessLevel}.`,
        comment: 'Tooltip for user getting access when moving an entry',
    });
    const partialAccessTooltip = t({
        message: 'Partial access means that they will see the parent folder, but only the content directly shared with them inside the folder',
        comment: 'Tooltip for user getting partial access when moving an entry',
    });
    if (willGainPartialAccess) {
        return (<Tooltip title={partialAccessTooltip}>
        <Chip appearance="secondary" variant="outline" label={<Box alignItems="center" gap="md">
              {getAccessLevelName(actions.next)}
            </Box>} size="medium"/>
      </Tooltip>);
    }
    return (<Tooltip title={tooltip}>
      <Box alignItems="center" gap="md">
        <Chip appearance="secondary" variant="outline" label={getAccessLevelName(actions.prev)} size="medium"/>
        <Falcon icon="arrow-right" $size={10}/>
        <Chip appearance="secondary" variant="outline" label={getAccessLevelName(actions.next)} size="medium"/>
      </Box>
    </Tooltip>);
}
